// src/Api/api.js
import React from 'react';
import axios from "axios";
import Cookies from "js-cookie";
import {
  browserName,
  browserVersion,
  osName,
  osVersion,
  deviceType
} from 'react-device-detect';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const getDeviceHeaders = () => {
  const deviceHeaders = {};

  // if (browserName) deviceHeaders["x-device"] = browserName;
  // if (browserVersion) deviceHeaders["X-Browser-Version"] = browserVersion;
  if (osName) deviceHeaders["x-platform"] = osName;
  if (osVersion) deviceHeaders["x-platform-version"] = osVersion;
  if (deviceType) deviceHeaders["x-device"] = deviceType;
  if (React.version) deviceHeaders["x-application-version"] = React.version;


  return deviceHeaders;
};


const apiCall = async ({ url, method = "GET", headers = {}, data = {}, token }) => {
  try {
    const isFormData = data instanceof FormData;
    const authToken =  Cookies.get("dcp_auth_token");
    // if (!authToken) {
    //   window.location.reload();
    // }
    const URL =`${BASE_URL}/${url}?access_token=${authToken}`
    const config = {
      method: method.toUpperCase(),
      url: URL,
      headers: {
        Accept: "application/json",
        'x-api-key': 'fc9f4a47-4f7f-41ba-a656-d30e0009d6f0',
        "Access-Control-Allow-Origin": "*",
        // ...(authToken && { Authorization: `Bearer ${authToken}` }),
        ...(isFormData
          ? { "Content-Type": "application/x-www-form-urlencoded" }
          : { "Content-Type": "application/json" }),
        // ...getDeviceHeaders(),
        ...headers,
      },
    };

    //set aata
    if (["POST", "PUT", "PATCH"].includes(method.toUpperCase())) {
      config.data = isFormData ? data : JSON.stringify(data);
    }

    const response = await axios(config);
    return response;
  } catch (error) {
    if (error.response) {
      if (error?.response?.status === 400) {
        throw {
          status: 400,
          data: error?.response?.data,
          message: error?.response?.data?.message,
        };
      }
    } else if (error.request) {
      console.error("Request made but no response:", error.request);
    } else {
      console.error("Axios setup error:", error.message);
    }

    return error.response || {
      status: 500,
      data: { message: "Unexpected error occurred" },
    };
  }
};

export default apiCall;

//When Url Provide in API internally (no need to add base url)

 export const apiCall2 = async ({ url, method = "GET", headers = {}, data = {} }) => {
  try {
    const isFormData = data instanceof FormData;

    const config = {
      method: method.toUpperCase(),
      url: url,
      headers: {
        Accept: "application/json",
        'x-api-key': 'fc9f4a47-4f7f-41ba-a656-d30e0009d6f0',
        "Access-Control-Allow-Origin": "*",
        // ...(authToken && { Authorization: `Bearer ${authToken}` }),
        ...(isFormData
          ? { "Content-Type": "application/x-www-form-urlencoded" }
          : { "Content-Type": "application/json" }),
        // ...getDeviceHeaders(),
        ...headers,
      },
    };

    //set aata
    if (["POST", "PUT", "PATCH"].includes(method.toUpperCase())) {
      config.data = isFormData ? data : JSON.stringify(data);
    }

    const response = await axios(config);
    return response;
  } catch (error) {
    if (error.response) {
      if (error?.response?.status === 400) {
        throw {
          status: 400,
          data: error?.response?.data,
          message: error?.response?.data?.message,
        };
      }
    } else if (error.request) {
      console.error("Request made but no response:", error.request);
    } else {
      console.error("Axios setup error:", error.message);
    }

    return error.response || {
      status: 500,
      data: { message: "Unexpected error occurred" },
    };
  }
};





